var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleCheck = function SvgScheduleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.75 3.5h-4.125V2.125a1.375 1.375 0 0 0-2.75 0V3.5h-13.75V2.125a1.375 1.375 0 0 0-2.75 0V3.5H3.25A2.75 2.75 0 0 0 .5 6.25v27.5a2.75 2.75 0 0 0 2.75 2.75h27.5a2.75 2.75 0 0 0 2.75-2.75V6.25a2.75 2.75 0 0 0-2.75-2.75M7.375 6.25v1.375a1.375 1.375 0 0 0 2.75 0V6.25h13.75v1.375a1.375 1.375 0 0 0 2.75 0V6.25h4.125v5.5H3.25v-5.5zm23.375 27.5H3.25V14.5h27.5zm-6.59-14.723a1.374 1.374 0 0 1 0 1.946l-8.25 8.25a1.374 1.374 0 0 1-1.945 0L9.84 25.098a1.376 1.376 0 1 1 1.945-1.946l3.153 3.154 7.277-7.279a1.374 1.374 0 0 1 1.945 0"
  })));
};
export default SvgScheduleCheck;